interface Exercise {
  day: string;
  category: string;
  id: number;
  exercise: string;
  exercise_en: string;
  exercise_pt: string;
  exercise_fr: string | null;
  rest: string;
  serie: string;
  super_serie: boolean;
  rep: string;
  intensity: string;
  target_muscle: string;
  commentary_custom: string;
  [key: string]: any;
}

interface DaySection {
  routine: Exercise[];
  min: number;
}

interface InputJSON {
  is_period: number;
  is_wizard: number;
  nowPlan: number;
  skip_to_planned: number;
  new_weeks_amount: number;
  user_id: number;
  week: number;
  name: string;
  objective: string;
  download: boolean;
  searchable: boolean;
  weeks: number;
  training: {
    [key: string]: {
      warm: DaySection;
      main: DaySection;
      stretching: DaySection;
    };
  };
}

interface OutputJSON {
  is_period: number;
  is_wizard: number;
  nowPlan: number;
  skip_to_planned: number;
  new_weeks_amount: number;
  user_id: number;
  week: number;
  days: {
    [key: string]: {
      warm: { exercises: Exercise[] };
      main: { exercises: Exercise[] };
      stretching: { exercises: Exercise[] };
    };
  };
  title: string;
  objective: string;
  searchable: boolean;
  is_download: string;
}

function transformTrainingPlan(input: InputJSON): OutputJSON {
  const dayMap: { [key: string]: string } = {
    l: "L",
    m: "M",
    x: "X",
    j: "J",
    v: "V",
    s: "S",
    d: "D",
  };

  const transformedDays: {
    [key: string]: {
      warm: { exercises: Exercise[]; min: number };
      main: { exercises: Exercise[]; min: number };
      stretching: { exercises: Exercise[]; min: number };
    };
  } = {};

  Object.entries(input.training).forEach(([dayKey, sections]) => {
    const capitalizedDay = dayMap[dayKey] || dayKey.toUpperCase();

    const transformExercises = (exercises: Exercise[]): Exercise[] | any => {
      return exercises.map((ex: any) => ({
        day: ex.day,
        category: ex.category,
        id: ex.exercise.id,
        rest: ex.break,
        serie: ex.serie,
        super_serie: ex.superSerie ? 1 : 0,
        rep: ex.repetitions,
        intensity: ex.intensity,
        target_muscle: ex.muscle,
        commentary_custom: ex.commentary_custom,
       evolutions: ex.evolutions,
      }));
    };

    /*     transformedDays[capitalizedDay] = {
      warm: { exercises: transformExercises(sections.warm.routine), min: sections.warm.min || 0 },
      main: { exercises: transformExercises(sections.main.routine), min: sections.main.min || 0 },
      stretching: { exercises: transformExercises(sections.stretching.routine), min: sections.stretching.min || 0 }
    }; */

    transformedDays[capitalizedDay] = {
      warm: {
        exercises: transformExercises(sections.warm.routine),
        min: sections.warm.min || 5,
      },
      main: {
        exercises: transformExercises(sections.main.routine),
        min: sections.main.min || 20,
      },
      stretching: {
        exercises: transformExercises(sections.stretching.routine),
        min: sections.stretching.min || 5,
      },
    };
  });

  return {
    is_period: input?.is_period,
    is_wizard: input?.is_wizard,
    nowPlan: input?.nowPlan,
    skip_to_planned: 0,
    new_weeks_amount: input.weeks,
    user_id: input?.user_id,
    week: input.weeks,
    days: transformedDays,
    title: input.name,
    objective: input.objective,
    searchable: input.searchable,
    is_download: input.download ? "off" : "on",
  };
}

export { transformTrainingPlan };
